
import { RolesModels } from '@/model/getRolesModel'
import { RootObject } from '@/model/rootObject'
import { Routes } from '@/model/routesModel'
import https from '@/utils/https'
import { RequestParams, ContentType, Method } from 'axios-mapper'

export const getRoutes = () => {
  return https().request<RootObject<Routes>>('roles/getRoutes', Method.GET, undefined, ContentType.form)
}

export const delRole = (id: number) => {
  return https().request<RootObject<String>>('roles/deleteRole', Method.DELETE, { id }, ContentType.form)
}

export const updateRole = (id: number, data: any) => {
  return https().request<RootObject<any>>(`roles/updateRole/${id}`, Method.POST, data, ContentType.form)
}

export const createRole = (role: RequestParams) => {
  return https().request<RootObject<any>>('roles/createRole', Method.PUT, role, ContentType.form)
}

// 查询角色列表
export const getroles = (role: RequestParams) => {
  return https().request<RootObject<any>>('role/all', Method.GET, role, ContentType.form)
}
// 新增角色列表
export const adddroles = (role: RequestParams) => {
  return https().request<RootObject<any>>('role/add', Method.POST, role, ContentType.json)
}
// 删除角色
export const deleteeroles = (role: RequestParams) => {
  return https().request<RootObject<any>>('role/delete', Method.DELETE, role, ContentType.form)
}
// 编辑角色
export const updateeroles = (role: RequestParams) => {
  return https().request<RootObject<any>>('role/update', Method.POST, role, ContentType.json)
}
// 获取账号列表
export const getaccuser = (role: RequestParams) => {
  return https().request<RootObject<any>>('/user', Method.GET, role, ContentType.form)
}
// 新增账号
export const addaccuser = (role: RequestParams) => {
  return https().request<RootObject<any>>('/user', Method.POST, role, ContentType.json)
}
// 删除账号
export const delaccuser = (role: RequestParams) => {
  return https().request<RootObject<any>>('/user', Method.DELETE, role, ContentType.form)
}
// 更新账号
export const upgradeaccuser = (role: RequestParams) => {
  return https().request<RootObject<any>>('/user/update', Method.POST, role, ContentType.json)
}
//查询账号详情
export const getaccuserdetails = (role: RequestParams) => {
  return https().request<RootObject<any>>('/user/detail', Method.GET, role, ContentType.form)
}
// 重置账号密码
export const replacementpswd = (role: RequestParams) => {
  return https().request<RootObject<any>>('/user/reset', Method.PUT, role, ContentType.form)
}
